import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

interface SearchProps {
  haveResults?: boolean;
}
export const Container = styled.div<SearchProps>`
  display: flex;
  position: absolute;
  background: #fff;
  width: 370px;
  flex-direction: column;
  max-height: 200px;
  margin-top: -8px;
  overflow-y: auto;
  border: ${({ haveResults }) => (haveResults ? '1px solid #d0dae3' : 'none')};
  border-top: none;
  border-radius: 0 0 8px 8px;
`;

export const Title = styled.div`
  font-size: 24px;
  color: #1a1b1c;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const WarningText = styled.h2`
  font-style: normal;
  display: flex;
  flex-direction: row;
  font-weight: normal;
  font-size: 14px;

  color: ${beam.font.error};
`;
export const Text = styled(WarningText)`
  color: ${beam.font.primary};
  width: fit-content;
  white-space: nowrap;
  margin-left: 8px;
`;
export const ButtonText = styled(WarningText)`
  color: ${beam.font.link};
  margin-left: 14px;
  cursor: pointer;
`;
export const WarningBoldText = styled(WarningText)`
  font-weight: bold;
`;
export const HeadRight = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
`;
export const HeadLeft = styled(HeadRight)`
  justify-content: flex-start;
`;
export const Button = styled.button`
  background: #1371fe;
  color: #fff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.161);
  font-weight: 500;
  font-size: 14px;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  margin-left: 24px;
  :disabled {
    opacity: 0.3;
  }
`;
export const Icon = styled.img`
  margin-right: 8px;
`;

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  flex: 1;
  margin-bottom: 8px;
`;

export const Search = styled.input<SearchProps>`
  background: ${beam.color.pureWhite};
  cursor: auto;
  /* borders/light-border */
  border: 1px solid #d0dae3;
  box-sizing: border-box;
  border-radius: ${({ haveResults }) => (haveResults ? '8px 8px 0 0' : '8px')};
  font-size: 14px;
  color: #787878;
  height: 36px;
  display: flex;
  align-items: center;
  flex: 1;
  width: 429px;
  padding-left: 31px;
  padding-right: 8px;
  -webkit-appearance: none;

  ::placeholder {
    color: #787878;
  }
  :disabled {
    cursor: default;
    padding-left: 8px;
    background: ${beam.border.back};
  }
`;

export const SearchImg = styled.img`
  position: absolute;
  left: 12px;
  z-index: 2;
`;

export const Line = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const RowDiv = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
`;

export const Count = styled.div`
  color: #1a1b1c;
  margin-left: 16px;
`;
export const SearchButton = styled.h1`
  color: ${beam.color.primaryBlue};
  right: 6px;
  position: absolute;
  font-weight: 500;
  font-style: normal;
  font-size: 12px;
  margin-right: 5px;
  cursor: pointer;
  margin-bottom: 0;
`;
export const Close = styled.img`
  cursor: pointer;
  margin-left: -21px;
  margin-right: 7px;
`;
export const LoadingImg = styled.img`
  height: 20px;
  width: 20px;
  margin-left: -25px;
  margin-right: 5px;
`;

export const StyledOption = styled.text`
  display: flex;
  user-select: none;
  align-items: flex-start;
  margin-top: 8px;
  padding: 8px 0;
  padding-left: 24px;
  justify-content: flex-start;
  text-align: start;
  width: 100%;
  cursor: pointer;
  :hover {
    background: ${beam.background.card};
  }
`;

export const StyledOptionBlue = styled(StyledOption)`
  color: ${beam.font.link};
  white-space: nowrap;
  padding-right: 8px;

  margin-bottom: 16px;
  :hover {
    background: ${beam.color.pureWhite};
  }
`;

export const StyledOptionCancel = styled(StyledOption)`
  margin-bottom: 16px;
  :hover {
    background: ${beam.color.pureWhite};
  }
`;

export const StyledOptionBlack = styled(StyledOption)`
  font-weight: 500;
  cursor: auto;
  :hover {
    background: ${beam.color.pureWhite};
  }
`;
